// extracted by mini-css-extract-plugin
export default {"document":"DocumentRenderer_document__q9jmC"};